import { TOP_TOPICS_TABLE_INITIAL_STATE } from "@/models/options";

const v7 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        topScriptTopicsTable: { ...TOP_TOPICS_TABLE_INITIAL_STATE },
        topThumbTopicsTable: { ...TOP_TOPICS_TABLE_INITIAL_STATE },
        topTitleTopicsTable: { ...TOP_TOPICS_TABLE_INITIAL_STATE },
        topVideoTypesTable: { ...TOP_TOPICS_TABLE_INITIAL_STATE },
      },
    },
  };
};

export default v7;
